module.exports = __webpack_public_path__ + "static/media/logo-h-dark.41d79588.svg";